<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="onClick"
  >
    <g clip-path="url(#clip0_332_326)">
      <path
        d="M9.99745 10.8797C12.4398 10.8797 14.4197 8.89976 14.4197 6.45741C14.4197 4.01507 12.4398 2.03516 9.99745 2.03516C7.55511 2.03516 5.5752 4.01507 5.5752 6.45741C5.5752 8.89976 7.55511 10.8797 9.99745 10.8797Z"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.409 19.7241C17.8378 17.9427 16.7156 16.3888 15.2043 15.2864C13.693 14.1839 11.8706 13.5898 9.99991 13.5898C8.12922 13.5898 6.30686 14.1839 4.79555 15.2864C3.28424 16.3888 2.16207 17.9427 1.59082 19.7241H18.409Z"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_332_326">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.879883)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "AppUserIcon",
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>
